'use client';

import './checkbox.scss';

import { trackClick } from '@sola/tracking/components/datalayer.js';

import {
  Field,
  FieldErrorIcon,
  FieldErrorMessage,
  type FieldProps,
  FieldWrapper,
  getErrorElId,
} from '../field/field';

export interface CheckboxProps extends Partial<
  Omit<
    FieldProps,
    | 'children'
    | 'min'
    | 'max'
    | 'valueAsNumber'
    | 'valueAsDate'
    | 'value'
    | 'defaultValue'
  >
> {
  label: string;
  checked?: boolean;
  checkboxRef?: React.MutableRefObject<HTMLInputElement>;
  defaultChecked?: boolean;
}

/**
 * Checkbox component which leverages our field functionality.
 */
export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checkboxRef,
  defaultChecked,
  ...props
}) => {
  return (
    <Field {...(props as FieldProps)} controlRef={checkboxRef}>
      {({ controlProps, error }) => {
        const errorElId = getErrorElId(controlProps.id);
        return (
          <>
            <FieldWrapper isCentered={false} className="Checkbox align-center">
              <FieldErrorIcon error={error} />
              <input
                className="Checkbox__input shrink-0"
                type="checkbox"
                defaultChecked={defaultChecked}
                onClick={() => {
                  trackClick(
                    label || 'Unlabeled Checkbox',
                    undefined,
                    'Checkbox__input',
                  );
                }}
                onChange={props.onChange}
                disabled={props.disabled}
                aria-errormessage={errorElId}
                {...controlProps}
                ref={controlProps.ref || checkboxRef}
              />
              <label
                className="Checkbox__label ml-comfy-xs"
                htmlFor={controlProps.id}
              >
                {label}
              </label>
            </FieldWrapper>
            <FieldErrorMessage error={error} id={errorElId} />
          </>
        );
      }}
    </Field>
  );
};
